/**
 * #327 — Monitoring endpoint URLs.
 * Defined here so they can be easily promoted to env vars later.
 * Source: 00_baseline/aws.md  auto_recorded.biz_ci_eip = 3.34.148.160
 *
 * #654 §R654-3 — `grafana` 는 공인 IP + HTTP 직링크(mixed-content 차단 + SG 밖 도달 불가)를
 * nginx(biz-fe) 443 종단의 같은 도메인 sub-path 프록시(`/grafana/`)로 전환. `prometheus` 는
 * raw query 도구라 사내망(SG 화이트리스트) 전용 유지 — `MONITORING_INTERNAL_ONLY` 플래그로
 * 노출 컴포넌트(MonitoringLinks)가 ROLE_ADMIN 조건 노출 + '사내망 전용' 배지를 판단한다.
 */
export const MONITORING_ENDPOINTS = {
  grafana: '/grafana/',
  prometheus: 'http://3.34.148.160:9090',
} as const;

/** #654 — 사내망(SG 화이트리스트) 밖에서 도달 불가한 엔드포인트 플래그. */
export const MONITORING_INTERNAL_ONLY: Partial<Record<keyof typeof MONITORING_ENDPOINTS, boolean>> = {
  prometheus: true,
};
